import React, { useState, useEffect, useContext } from "react";
import * as FaIcons from "react-icons/fa";
import IntersessionRow from "./IntersessionRow";
import AuthContext from "../../context/auth/authContext";

const headers = [
  { name: "name", display: "Name", sortable: true },
  { name: "status", display: "Status", sortable: true },
  { name: "schoolYear", display: "School Year", sortable: true, style: { width: "30%" } },
  { name: "editProfile", display: "Edit Profile", sortable: false, style: { width: "15%" } },
  { name: "setupCourses", display: "Setup Courses", sortable: false, style: { width: "20%" } },
];

const TableHeaderItem = ({ name, display, style, onClick, sortOptions, sortable }) => {
  return (
    <th style={{ ...style }} onClick={() => sortable && onClick(name)}>
      <div className="wrap">
        <span>{display}</span>
        {sortable && (
          <div className="filter">
            <FaIcons.FaSortUp
              style={{ color: sortOptions[name].asc ? "#343434" : "white" }}
            />
            <FaIcons.FaSortDown
              style={{ color: sortOptions[name].desc ? "#343434" : "white" }}
            />
          </div>
        )}
      </div>
    </th>
  );
};

const IntersessionTable = ({ items }) => {
  const authContext = useContext(AuthContext);
  const { user } = authContext;
  const filteredHeaders = headers.filter(header =>
    header.name !== "editProfile" || (user && (user.userStatus === "Admin" || user.userStatus === "Super Admin"))
  );
  const [sortOptions, setSortOptions] = useState(
    headers.reduce((acc, header) => {
      acc[header.name] = { asc: false, desc: false };
      return acc;
    }, {})
  );

  const [sortedItems, setSortedItems] = useState(items);

  useEffect(() => {
    setSortedItems(items);
  }, [items]);

  const handleHeaderClick = (payload) => {
    if (!headers.find(header => header.name === payload).sortable) {
      return;
    }

    let asc = sortOptions[payload].asc === false;
    let normal = sortOptions[payload].desc === true;

    const sortedItems = [...items].sort((a, b) => {
      if (normal) {
        return a["createdAt"] < b["createdAt"] ? 1 : -1;
      } else if (asc) {
        return a[payload] > b[payload] ? 1 : -1;
      } else {
        return a[payload] < b[payload] ? 1 : -1;
      }
    });

    setSortOptions((prevState) => ({
      ...headers.reduce((acc, header) => {
        acc[header.name] = { asc: false, desc: false };
        return acc;
      }, {}),
      [payload]: normal
        ? { asc: false, desc: false }
        : asc
        ? { asc: true, desc: false }
        : { asc: false, desc: true },
    }));

    setSortedItems(sortedItems);
  };

  return (
    <div className="interest-form-table">
      <table id="interest-table">  
        <thead>
          <tr>
            {filteredHeaders.map((header, index) => (
              <TableHeaderItem
                key={index}
                name={header.name}
                display={header.display}
                style={header.style}
                onClick={handleHeaderClick}
                sortOptions={sortOptions}
                sortable={header.sortable}
              />
            ))}
          </tr>
        </thead>
        <tbody>
          {sortedItems && sortedItems.length > 0 ? (
            sortedItems.map((item, index) => (
              <IntersessionRow key={index} info={item} />
            ))
          ) : (
            <tr>
              <td colSpan={headers.length}>No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default IntersessionTable;